import React from 'react';
import PropTypes from 'prop-types';

import styles from './Layout.scss';

const Layout = ({ children }) => (
  <div className={styles.wrapper}>
    {children}
  </div>
);

Layout.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.element),
    PropTypes.node
  ]).isRequired
};

export default Layout;



// WEBPACK FOOTER //
// ./src/containers/Layout/Layout.js